import update from 'immutability-helper';
import { REHYDRATE } from 'redux-persist/lib/constants';
import { createReducer } from '../modules/helpers';

import { ActionTypes } from '../constants/index';

export const appState = {
  updateAvailable: false,
  alerts: [],
  error: false,
};

export const appReducer = createReducer(appState, {
  [REHYDRATE](state) {
    return update(state, {
      alerts: { $set: [] },
    });
  },

  [ActionTypes.APP_UPDATE_AVAILABLE](state) {
    const { updateAvailable } = state;
    if (updateAvailable === false) {
      return update(state, {
        updateAvailable: { $set: true },
      });
    }
    return state;
  },

  [ActionTypes.NETWORK_ERROR](state) {
    return update(state, {
      error: { $set: true },
    });
  },

  [ActionTypes.NETWORK_SUCCESS](state) {
    return update(state, {
      error: { $set: false },
    });
  },
});



// WEBPACK FOOTER //
// ./scripts/reducers/app.js